<div class="featured-product-section">
    <div class="desc-section col-md-5 col-xl-6">
        <div class="category-holder">
            <div class="divider"></div>
            <span class="cat-name">{{ "landing.masoneilan" | cxTranslate }}</span>
        </div>
        <p class="title mb-0">{{ "landing.featuredproduct" | cxTranslate }}</p>
        <p class="subtitle mb-3">{{ "landing.accurate" | cxTranslate }}</p>
        <p class="desc">{{ "landing.thirdgen" | cxTranslate }}</p>
    </div>
    <div class="details-section col-md-7 col-xl-6">
        <p class="title mb-0">{{ "landing.masoneilansvi" | cxTranslate }}</p>
        <p class="subtitle mb-3">{{ "landing.digitalvalve" | cxTranslate }}</p>
        <p class="desc">{{ "landing.reliableaccurate" | cxTranslate }}</p>
        <button class="vs-primary-btn" (click)="redirectToFeaturedProduct()">
            <span>{{ "landing.viewproduct" | cxTranslate }}</span>
        </button>
    </div>
</div>